module.exports = __webpack_public_path__ + "img/caatinga.9ecf454d.png";